import { render } from "./BusinessQuotes.vue?vue&type=template&id=5ce41f39"
import script from "./BusinessQuotes.vue?vue&type=script&lang=js"
export * from "./BusinessQuotes.vue?vue&type=script&lang=js"

import "./BusinessQuotes.vue?vue&type=style&index=0&id=5ce41f39&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__